module.exports = __webpack_public_path__ + "static/media/lasso.2d64c81b.svg";